import { ChangeEvent, FC, useMemo, useState } from 'react';

import debounce from 'lodash/debounce';

import { SearchBox } from './CheckboxFilterTree.styles';
import { MIN_SEARCH_KEYWORD_LENGTH, SEARCH_DEBOUNCE_TIME } from './constants';

const noop = () => undefined;

export type FilterTreeSearchProps = {
    searchEnabled?: boolean;
    searchPlaceholder?: string;
    searchAllyLabel?: string;
    searchClearButtonAllyLabel?: string;
};
type Props = FilterTreeSearchProps & { onSearchChange?: (searchValue: string) => void };

export const FilterTreeSearch: FC<Props> = ({
    searchEnabled,
    searchPlaceholder,
    searchAllyLabel,
    searchClearButtonAllyLabel,
    onSearchChange = noop,
}) => {
    const [value, setValue] = useState('');
    const triggerOnSearchChange = useMemo(() => debounce(onSearchChange, SEARCH_DEBOUNCE_TIME), [onSearchChange]);

    if (!searchEnabled) {
        return null;
    }

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setValue(newValue);

        const trimmed = newValue.trim().toLowerCase();
        const parsed = trimmed.length >= MIN_SEARCH_KEYWORD_LENGTH ? trimmed : '';
        triggerOnSearchChange(parsed);
    };

    return (
        <SearchBox
            variant="no-button"
            aria-label={searchAllyLabel}
            clearButtonAriaLabel={searchClearButtonAllyLabel}
            placeholder={searchPlaceholder}
            onClear={() => {
                setValue('');
                onSearchChange('');
            }}
            onChange={handleChange}
            value={value}
        />
    );
};
